module.exports = __webpack_public_path__ + "fonts/AkkuratLL-Regular.d5120bf5.otf";